'use client';
import React from 'react';

import Hooks from '@benzinga/hooks';
import { SessionContext } from '@benzinga/session-context';
import { ChartConfigManager } from '@benzinga/chart-config-manager';

export const useVisibleCharts = () => {
  const session = React.useContext(SessionContext);

  const [charts, setCharts] = React.useState(() => session.getManager(ChartConfigManager).getCachedVisibleCharts());
  React.useEffect(() => {
    session.getManager(ChartConfigManager).getVisibleCharts();
  }, [session]);

  Hooks.useSubscriber(session.getManager(ChartConfigManager), event => {
    switch (event.type) {
      case 'chart-config:visible-charts-updated':
        setCharts(event.charts);
        break;
      case 'chart-config:post-chart-updated':
      case 'chart-config:chart-deleted':
        session.getManager(ChartConfigManager).getCharts();
        break;
    }
  });

  return charts;
};
